// Measuring text for the People table, so column widths come from all the data (not just the
// rows on screen, which would make columns jump while scrolling) and rows with long notes get
// the height they need.

let ctx: CanvasRenderingContext2D | null = null;
let family = '';

function context(): CanvasRenderingContext2D | null {
  if (!ctx && typeof document !== 'undefined') {
    ctx = document.createElement('canvas').getContext('2d');
    family = getComputedStyle(document.body).fontFamily || 'system-ui, sans-serif';
  }
  return ctx;
}

export function font(size: number, weight = 400): string {
  context();
  return `${weight} ${size}px ${family}`;
}

const cache = new Map<string, number>();

export function textWidth(text: string, f: string): number {
  if (!text) return 0;
  const key = f + '\u0000' + text;
  let w = cache.get(key);
  if (w === undefined) {
    const c = context();
    if (!c) return text.length * 7;
    c.font = f;
    w = c.measureText(text).width;
    if (cache.size > 50_000) cache.clear();
    cache.set(key, w);
  }
  return w;
}

/** How many lines `text` wraps to at `width` (words wrap; a word longer than the line breaks anywhere). */
export function lineCount(text: string, width: number, f: string): number {
  if (!text) return 1;
  let lines = 0;
  for (const para of text.split('\n')) {
    let line = 0;
    lines++;
    for (const word of para.split(/(\s+)/)) {
      if (!word) continue;
      const w = textWidth(word, f);
      if (line + w <= width || (line === 0 && /^\s+$/.test(word))) {
        line += w;
      } else if (/^\s+$/.test(word)) {
        // Spaces at the end of a line don't take room.
        continue;
      } else if (w > width) {
        // Overlong word (a URL): it fills whole lines.
        const extra = Math.ceil((line + w) / width) - 1;
        lines += extra;
        line = (line + w) % width;
      } else {
        lines++;
        line = w;
      }
    }
  }
  return lines;
}
